export const BULK_EXPORTS_TYPE = 'bulkExports';
export const TERRITORY_EXPORT_TYPE = 'territoryExport';
export const REGION_ANALYTICS_TYPE = 'regionAnalytics';
export const TRENDING_ANALYTICS_TYPE = 'trendingAnalytics';
export const AVAILABLE_DATA_RANGE_TYPE = 'availableDataRange';
